var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconBulb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.25v2.25a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 19.5v-2.25m3-16.5v1.5m-10.5 9H3m.75-7.5 1.1 1.057M22.5 11.25H21m-.75-7.5-1.1 1.057M8.915 17.25h6.17a6.6 6.6 0 0 0 3.665-6A6.873 6.873 0 0 0 12 4.5a6.873 6.873 0 0 0-6.75 6.754 6.6 6.6 0 0 0 3.665 5.996ZM12 21v2.25m0-9.75v3.75",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 11.25 12 13.5l2.25-2.25",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconBulb);
export default __webpack_public_path__ + "static/media/streamline-icon-bulb.aa0cad69.svg";
export { ForwardRef as ReactComponent };